// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__Kv852","fileBtn":"File_fileBtn__-wj_R","closeBtn":"File_closeBtn__3HHZZ","fileSelected":"File_fileSelected__3sWjg","disabled":"File_disabled__mvnMv"};